import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MAIN_MENU_ITEMS, BOTTOM_MENU_ITEMS } from "../../constants";
import { useSelector, useDispatch } from "react-redux";
import { selectMenu } from "../../store/common/menuSlice";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Tooltip } from "../common/Tooltip";
import { redeemPointFun } from "../../thunks/dashboardThunks";
import { getFromLocal } from "../../utils/localStorage";


const Sidebar = () => {
  const selectedMenu = useSelector((state) => state.menu.selectedMenu);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [alertText, setAlertText] = useState("");
  const [url, setUrl] = useState("");
  const [couponValue, setCouponValue] = useState("");
  const [showPopup, setShowPopup] = useState(false); // State for pop-up visibility
  const user_id = getFromLocal("userId");
  const trial = useSelector((state) => state?.user?.details?.data?.trial);
  
  useEffect(() => {
    if (alertText !== "" && url !== "") {
      showAlert();
    }
  }, [alertText, url]);

  const handleMenuClick = (item) => {
    const { name, url, onClick, id } = item;
    dispatch(selectMenu(name));
    if (onClick) {
      return onClick();
    }
    if (url) {
      if (url.startsWith("http")) {
        window.location.href = url;
      } else {
        navigate(url);
      }
    }
    if (id === "redeemPoints") {
      showRedeemPointsPopover();
    }
  };

  const main_menu = MAIN_MENU_ITEMS(trial);

  useEffect(() => {
    // Update selected menu based on current URL
    const currentUrl = window.location.pathname;
    const matchedMenuItem = main_menu.find((item) => currentUrl === item.url);
    if (matchedMenuItem) {
      dispatch(selectMenu(matchedMenuItem.name));
    } else {
      dispatch(selectMenu("Home")); // Default selected menu
    }
  }, [selectedMenu]);

  const handleReviewClick = (text, url) => {
    setAlertText(text);
    setUrl(url);
    showAlert();
  };

  const showRedeemPointsPopover = () => {
    Swal.fire({
      title: "Redeem Your Coupon",
      html: `<h6>Take advantage of this opportunity, redeem your coupon, and let the joy of savings enhance your experience, making each transaction a little more rewarding.</h6>  <br/>
             <input id="couponInput"  placeholder="Enter your coupon value..." /> `,
      htmlposition: "top-start",
      confirmButtonColor: "#FFBC00",
      confirmButtonText: "Redeem Now ",

      preConfirm: () => {
        const couponValue = document.getElementById("couponInput").value;
        let newCode = couponValue?.trim();
        dispatch(redeemPointFun({ user_id: user_id, code: newCode }));
        setCouponValue(couponValue);
      },
    });
  };

  const showAlert = () => {
    Swal.fire({
      html: `
        <h6>
          Please considers leaving a review for <b>vidBoard.ai</b> on
          <b>${alertText}</b>. Your honest review helps us improve and lets
          others know about the amazing experiences you've had with our product.
        </h6>
        `,
      htmlposition: "top-start",
      confirmButtonColor: "#FFBC00",
      confirmButtonText: `Go to ${alertText}`,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = url;
      }
    });
  };

  const handleVisitChannelClick = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="w-15 bg-white shadow-md fixed h-screen z-10">
      <a href="https://www.vidboard.ai/">
        <div className="flex items-center justify-start ml-2 pl-4 py-4">
          <img
            src="/tool/dashboard/static/images/logo-192.png"
            alt="Logo"
            className="w-8 h-8 mr-0"
          />
          <span className="text-xl font-semibold">vidBoard.ai</span>
        </div>
      </a>

      <div className="space-y-1">
        {(main_menu || []).map((item) => (
          <div
            key={item.name}
            onClick={() => !item.disabled && handleMenuClick(item)}
            className={`px-6 ${
              !item.disabled && "cursor-pointer"
            }  rounded-lg relative group `}
          >
            {item.showTooltip && (
              <Tooltip className={"left-[90%] top-0 whitespace-nowrap"}>
                Coming soon
              </Tooltip>
            )}
            <div
              className={`p-2 py-1 hover:bg-gray-100 flex items-center space-x-2  rounded-lg text-sm ${
                selectedMenu === item.name ? "bg-gradient" : ""
              }`}
            >
              <div>
                <FontAwesomeIcon
                  icon={item.icon}
                  className={
                    selectedMenu === item.name ? "text-white" : "text-gray-700"
                  }
                />
              </div>
              <span
                className={`us ${
                  selectedMenu === item.name
                    ? "text-white font-bold"
                    : "text-gray-700"
                }`}
              >
                {item.name}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="fixed bottom-5 w-15 space-y-2">
        <div className="border-2 w-[80%] mx-auto rounded-xl overflow-hidden mb-4">
          <div className="py-4 px-2">
            <img
              src="/tool/dashboard/static/images/YTlogo.png"
              className="w-[60%] mb-4"
            />
            <p className="text-xs">
              Visit our YouTube channel for tutorials, updates and more content.
            </p>
          </div>
          <button
            className="hover:bg-slate-600 hover:text-white w-[100%] text-sm bg-gray-200 py-2"
            onClick={handleVisitChannelClick}
          >
            Visit Channel
          </button>
        </div>
        {BOTTOM_MENU_ITEMS.map((item) => (
          <div
            key={item.name}
            onClick={() => handleMenuClick(item)}
            className={`px-6 cursor-pointer rounded-lg `}
          >
            <div
              className={`p-2 py-1  hover:shadow-md flex items-center space-x-2 rounded-lg text-sm ${
                selectedMenu === item.name ? "drop-shadow  text-white" : " "
              } ${item.name === "Ask For Help" ? "bg-gradient" : ""}`}
            >
              <div>
                <FontAwesomeIcon
                  icon={item.icon}
                  className={
                    selectedMenu === item.name
                      ? "text-white"
                      : item.name === "Ask For Help"
                      ? "text-white"
                      : "text-gray-700"
                  }
                />
              </div>
              <span
                className={
                  selectedMenu === item.name || item.name === "Ask For Help"
                    ? "text-white font-bold"
                    : "text-gray-700 font-medium"
                }
              >
                {item.name}
              </span>
            </div>
          </div>
        ))}
      </div>

      {showPopup && (
        <div className="fixed inset-0 bg-gray-500  bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white  rounded-lg z-50 w-[50%] h-[60%] justify-center " >
          <button 
              className=" text-gray-700 rounded-lg ml-[95%] mt-2"
              onClick={closePopup}
            >&#x2715;
            </button>
       <div className="flex items-center mx-2 pt-6 mb-[3%]">
            <div className="  w-[60%]  h-[100%] pl-6 flex flex-col items-center">
            <h1 className="text-3xl  text-[#11142D]  font-bold ">Here's your chance to get an additional <b className="bg-gradient-to-r from-pink-600 to-red-500 text-transparent bg-clip-text"> free video</b> </h1>
            <ul className=" pr-8 pl-2 mt-2  p-2 text-[#11142D]">
              <div className="flex flex-row ">
              <div className="bg-gradient-to-r from-pink-600 to-red-500 text-transparent bg-clip-text font-bold mt-2 text-sm  rounded-[100%] mr-4">1</div>
            <li> Subscribe to our <b className="underline">YouTube channel</b>  and be part of our creative community.</li></div>


            <div className="flex flex-row mt-2">
              <div className="bg-gradient-to-r from-pink-600 to-red-500 text-transparent bg-clip-text font-bold  mt-2 text-sm      rounded-[100%] mr-4">2</div>
            <li> Take a <b className="underline">screenshot</b>  to show us you've subscribed.</li></div>

            <div className="flex flex-row mt-2">
              <div className="bg-gradient-to-r from-pink-600 to-red-500 text-transparent bg-clip-text font-bold  text-sm    mt-1  rounded-[100%] mr-4">3</div>
            <li> Send the screenshot to <b className="underline">admin@vidboard.ai.</b>  </li></div>

            <div className="flex flex-row mt-2">
              <div className="bg-gradient-to-r from-pink-600 to-red-500 text-transparent bg-clip-text font-bold  mt-2  text-sm     rounded-[100%] mr-4">4</div>
            <li>  Upon receiving your email, the additonal <b className="underline">free video</b> will be reflected on your account. </li></div>
            
            </ul>
            </div>
            <div className="w-[40%] p-6 mt-2">
           
              <img className=" rounded" src="/tool/dashboard/static/images/vbYT.gif"/>
              <a href="https://www.youtube.com/@vidBoardai"><button className="text-white mt-4 p-2 w-full rounded bg-[#11142D]"> Subscribe now</button></a>
            </div>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
